import React from 'react';
import MobileAdhesionFs from './freestar/Adhesion';
const MobileAdhesion = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(MobileAdhesionFs, {
        safety: safety
    });
};
MobileAdhesion.displayName = 'MobileAdhesion';
export default MobileAdhesion;
